export default __webpack_public_path__ + "static/media/popup.55c985a7.svg";